<template>
  <div class="element-input element-calendar" :class="{ empty: !value }">
    <div class="label">{{ label }}</div>
    <div class="body">
      <i class="material-icons">expand_more</i>
      <datepicker :language="ko" :disabled-dates="disabledDates" @selected="selectDate" :value="date"
      :format="'yyyy. MM. dd'" :input-class="'cal-input'" :wrapper-class="'cal-wrap'" :calendar-class="'cal'"></datepicker>
    </div>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>

import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale'

export default {
  props: [ "value", "label", "error", "items", "disabled", "placeholder", 'isWeekend', 'isBirth'],
  data() {
    return {
      ko: ko,
      date: this.value,
      today: new Date(),
      disabledDates: {
        to: this.today,
        days: [6, 0],
        customPredictor: this.customPredictor
      }
    }
  },
  created() {
    this.today.setDate(this.today.getDate() - 1);
    if(this.$moment(this.value).day() == 0){ // 일요일인 경우 
      this.date = this.$moment(this.value).add(1, 'days').format(); // +1
    }else if(this.$moment(this.value).day() == 6){ // 토요일인 경우
      this.date = this.$moment(this.value).add(2, 'days').format(); // +2
    }

    if (this.$moment(this.value).month() + 1 === 9) {
      if (this.$moment(this.value).date() > 7 && this.$moment(this.value).date() < 13) {
        this.date = new Date('2022-09-13 09:00:00');
      }
    }

    this.selectDate(this.date)

    if (!this.isBirth) {
      this.disabledDates.to = this.today;
    } else {
      this.disabledDates = { days: [] };
    }

    if (this.isWeekend) {
      this.disabledDates = { to: this.today }
    }
  },
  components: {
    Datepicker
  },
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  methods: {
    selectDate( date ) {
      this.$emit( "input", date );
    },
    customPredictor(date) {
      const month = date.getMonth() + 1;
      const day = date.getDate();

      if (month === 9 && (day === 9 || day === 12)) {
        return true;
      }
    }
  }
}
</script>
